import { defineStore } from 'pinia'
import type { RouteNamedMap } from 'vue-router/auto-routes'
import { useAuthStore } from '@/plugins/auth'
import { UserRole } from '@/plugins/auth/types'
import type { RouteName } from './types'

const ADMIN_ROLES = [UserRole.ROLE_CONFIGURATION_ADMIN]
const CONFIGURATION_EDITOR_ROLES = [
    ...ADMIN_ROLES,
    UserRole.ROLE_CONFIGURATION_EDITOR,
]
const SUPER_ADMIN_ROLES = [UserRole.ROLE_CONFIGURATION_SUPER_ADMIN]
const USER_EDITOR_ROLES = [UserRole.ROLE_USER_CORPORATE_EDITOR]

const CONFIGURATION_EDITOR_ROUTES: (keyof RouteNamedMap)[] = [
    '/schema-playground/',
]

export const usePermissionStore = defineStore('permissionStore', () => {
    const authStore = useAuthStore()

    const isConfigurationEditor = computed(() =>
        authStore.hasRole(CONFIGURATION_EDITOR_ROLES)
    )

    const isAdmin = computed(() => authStore.hasRole(ADMIN_ROLES))

    const isSuperAdmin = computed(() => authStore.hasRole(SUPER_ADMIN_ROLES))

    const isUserEditor = computed(() => authStore.hasRole(USER_EDITOR_ROLES))

    const hasAccess = (routeName: RouteName) => {
        if (CONFIGURATION_EDITOR_ROUTES.includes(routeName)) {
            return isConfigurationEditor.value
        }

        return true
    }

    return {
        hasAccess,
        isAdmin,
        isConfigurationEditor,
        isSuperAdmin,
        isUserEditor,
    }
})
